export const isDark =
  window.matchMedia &&
  window.matchMedia("(prefers-color-scheme: dark)").matches;

export const styleClassName = (className: string) =>
  isDark ? `${className} is-dark` : className;
